// import React, { useEffect, useState } from "react";

// function TimePicker(){
//     const [time,setTime] =useState(new Date())
    
//     useEffect(()=>{
//         setInterval(()=>setTime(new Date()),1000)
//     },[])

//     return(
//         <div>
//             <p>{time.toLocaleTimeString()}</p>
//         </div>
//     )
// }

// export default TimePicker;

import React, { useRef, useEffect } from "react";
import { Typography } from "@mui/material";

export default function TimePicker() {
  const timeRef = useRef();

  useEffect(() => {
    const update = () => {
      // ONLY UPDATING DOM - NOT TOUCHING DATABASE
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      
      // Convert to 12-hour format
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const displayHours = hours % 12 || 12; // Convert 0 to 12
      
      // Format with leading zeros (no seconds)
      const formattedTime = `${displayHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${ampm}`;
      
      timeRef.current.textContent = formattedTime;
    };
    
    const timer = setInterval(update, 1000);
    update(); // Initial render
    
    return () => clearInterval(timer);
  }, []);

  return (
    <Typography 
      ref={timeRef}
      sx={{ 
        color: "#1f2937",
        fontSize: "2.5rem",
        fontWeight: 700,
        marginBottom: 2,
        fontFamily: "monospace",
        textShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        textAlign: "center"
      }}
    />
  );
}